import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
const LegalEntitySelector = ({ entities, selectedId, onChange }) => {
    const items = useMemo(() => entities.map(e => ({ key: e.id, label: e.name })), [entities]);
    const selectedItem = useMemo(() => items.find(i => i.key === selectedId) || null, [
        items,
        selectedId,
    ]);
    if (entities.length > 5) {
        return (_jsx("div", Object.assign({ className: "margin10B" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-md-3" }, { children: _jsx(AutoComplete, { id: "legalEntitySelector", items: items, value: selectedItem, onChange: (item) => {
                            if (!item)
                                return;
                            const entity = entities.find(e => e.id === item.key);
                            if (entity)
                                onChange(entity);
                        }, mode: "edit", canClear: false }) })) })) })));
    }
    return (_jsx("ul", Object.assign({ className: "nav nav-tabs nav-tabs-heading", role: "tablist" }, { children: entities.map(entity => (_jsx("li", Object.assign({ role: "presentation", className: `tab${selectedId === entity.id ? ' active' : ''}`, onClick: () => onChange(entity) }, { children: _jsx("span", { children: entity.name }) }), entity.id))) })));
};
export default LegalEntitySelector;
